<template>
  <el-form ref="form" :model="data" :rules="rules" label-width="100px">
    <el-form-item label="账号" prop="name">
      <el-input v-model.trim="data.name" placeholder="请填写账号" />
    </el-form-item>

    <el-form-item label="真实姓名" prop="realName">
      <el-input v-model.trim="data.realName" placeholder="请填写昵称" />
    </el-form-item>

    <el-form-item label="邮箱" prop="email">
      <el-input v-model.trim="data.email" placeholder="请填写邮箱" />
    </el-form-item>

    <el-form-item label="手机号" prop="phone">
      <el-input v-model.trim="data.phone" placeholder="请填写手机号" />
    </el-form-item>

    <el-form-item label="分组" prop="group_id">
      <!-- <el-select v-model="data.group_id" clearable :placeholder="'请选择至少一个分组'">
        <el-option v-for="itm in groups" :key="itm.id" :label="itm.title" :value="itm.id" v-html="(itm.spacer ? itm.spacer : '') + itm.title" />
      </el-select> -->
      <el-cascader
        v-model="data.group_id"
        placeholder="请选择至少一个分组"
        clearable
        :options="groups"
        :props="{value: 'id', label: 'title', checkStrictly: 'checkStrictly'}"
        filterable
        @change="handleSelect"
      />
    </el-form-item>

    <el-form-item label="简介" prop="introduce">
      <el-input v-model.trim="data.introduce" type="textarea" rows="6" placeholder="请填写简介" />
    </el-form-item>

    <!-- <el-form-item label="头像">
      <div style="width: 100%;">
        <avatar :data="data" />
      </div>
    </el-form-item> -->

    <el-form-item label="状态" prop="status">
      <el-radio-group v-model="data.status">
        <el-radio :label="1">{{ '启用' }}</el-radio>
        <el-radio :label="0">{{ '禁用' }}</el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submit">{{ '提交' }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
// import Avatar from './Avatar'
import {
  getGroups,
  createAdmin
} from '@/api/admin'
// import { Children } from 'react/cjs/react.production.min'

export default {
  name: 'AdminCreate',
  components: { /* Avatar */ },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '昵称不能为空', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '手机不能为空', trigger: 'blur' }
        ],
        group_id: [
          { required: true, message: '所属分组不能为空', trigger: 'blur' }
        ],
        introduce: [
          { required: true, message: '简介不能为空', trigger: 'blur' }
        ]
      },
      data: {
        name: '',
        realName: '',
        email: '',
        group_id: '',
        avatar: '',
        avatarKey: '',
        introduce: '',
        status: 1,
        phone: ''
      },
      groups: []
    }
  },
  watch: {
    item: {
      handler(val, oldVal) {
        if (this.item.dialogVisible === true) {
          this.$refs.form.resetFields()
          this.getGroups()
        }
      },
      deep: true
    }
  },
  created() {
    this.getGroups()
  },
  methods: {
    // 获取分组列表
    async getGroups() {
      const res = await getGroups()
      this.groups = res.data.list
    },
    handleSelect(e) {
      this.data.group_id = e[e.length - 1]
      console.log(e, this.data.group_id)
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return false
        }
        createAdmin(this.data).then(response => {
          this.data = {
            name: '',
            realName: '',
            email: '',
            group_id: '',
            avatar: '',
            avatarKey: '',
            introduce: '',
            status: 1,
            phone: ''
          }
          this.$emit('getNewAdminList')
          this.item.dialogVisible = false
          this.$message({
            message: '添加管理员成功',
            type: 'success',
            duration: 5 * 1000,
            onClose() {
              if (this.$refs.form !== undefined) {
                this.$refs.form.resetFields()
              }
            }
          })
        })
      })
    }
  }
}
</script>
